import { useRef, useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Eraser } from "lucide-react";

export function SignaturePad({ onChange, height = 160 }) {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const [empty, setEmpty] = useState(true);

  useEffect(() => {
    const c = canvasRef.current;
    const ctx = c.getContext("2d");
    ctx.lineWidth = 2.2; ctx.lineCap = "round"; ctx.strokeStyle = "#1e293b";
  }, []);

  const pos = (e) => {
    const c = canvasRef.current;
    const r = c.getBoundingClientRect();
    const t = e.touches ? e.touches[0] : e;
    // Canvas has a fixed internal resolution but is stretched to fit its container
    // (w-full), so map display coordinates into the canvas coordinate space.
    return { x: (t.clientX - r.left) * (c.width / r.width),
             y: (t.clientY - r.top) * (c.height / r.height) };
  };
  const start = (e) => { e.preventDefault(); drawing.current = true; const { x, y } = pos(e); const ctx = canvasRef.current.getContext("2d"); ctx.beginPath(); ctx.moveTo(x, y); };
  const move = (e) => { if (!drawing.current) return; e.preventDefault(); const { x, y } = pos(e); const ctx = canvasRef.current.getContext("2d"); ctx.lineTo(x, y); ctx.stroke(); if (empty) setEmpty(false); };
  const end = () => { if (!drawing.current) return; drawing.current = false; onChange?.(empty ? "" : canvasRef.current.toDataURL("image/png")); };
  const clear = () => { const c = canvasRef.current; c.getContext("2d").clearRect(0, 0, c.width, c.height); setEmpty(true); onChange?.(""); };

  return (
    <div>
      <div className="rounded-lg border-2 border-dashed border-slate-300 bg-white relative overflow-hidden">
        <canvas ref={canvasRef} width={520} height={height} className="w-full touch-none cursor-crosshair"
          data-testid="signature-canvas"
          onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
          onTouchStart={start} onTouchMove={move} onTouchEnd={end} />
        {empty && <div className="absolute inset-0 flex items-center justify-center text-slate-300 text-sm pointer-events-none">Sign here</div>}
      </div>
      <button type="button" onClick={clear} className="mt-1.5 flex items-center gap-1 text-[11px] text-slate-500 hover:text-slate-800" data-testid="signature-clear">
        <Eraser className="h-3 w-3" /> Clear
      </button>
    </div>
  );
}
